import { GENERATE_VIEW_DOCUMENT_LINK_ADD_LOG, RESET_GENERATE_VIEW_DOCUMENT_LINK_ADD_LOG } from "../../actionTypes/actionsTypes";
import defaultAsyncReducerWithReset from "../../defaultReducerReset";
import { AppAction, BaseAsyncReducerState } from "../../types";


// Define an initial state value for the app
const initialState: BaseAsyncReducerState = {
    loading: false,
    error: false,
    success: false,
}

function generateDocumentViewerLinkAddLogReducer(state = initialState, action: AppAction) {
    return defaultAsyncReducerWithReset(state, action, GENERATE_VIEW_DOCUMENT_LINK_ADD_LOG, RESET_GENERATE_VIEW_DOCUMENT_LINK_ADD_LOG, initialState)
}

export default generateDocumentViewerLinkAddLogReducer;